import { render, staticRenderFns } from "./hotFund.vue?vue&type=template&id=159dd0f3"
import script from "./hotFund.vue?vue&type=script&lang=js"
export * from "./hotFund.vue?vue&type=script&lang=js"
import style0 from "./hotFund.vue?vue&type=style&index=0&id=159dd0f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports